import React, { useEffect, useState } from 'react';
import Footer from '../components/Footer';
import Header from '../components/Header';
import Swal from 'sweetalert2';
import { generateAxiosInstance } from '../hooks/useAuthorizedRequest';
import { generateAxiosInstanceSection } from '../hooks/useAuthorizedRequestForSection';
import { generateAxiosInstanceInstitute } from '../hooks/useAuthorizedRequestForInstitute';
import { useNavigate } from 'react-router-dom';
import { Loader } from '../components/ModalsCommonFunctions';
import { findPageNumber, searchArray, SortIcon } from '../components/Navigation';
import Pagination from '../components/Pagination';

const AppRegisteredStudentList = () => {
    const authorizedAxios = generateAxiosInstance()
    const authorizedAxiosSection = generateAxiosInstanceSection()
    const authorizedAxiosInstitute = generateAxiosInstanceInstitute()
    let instituteMasterId = process.env.REACT_APP_REGISTER_INSTITUTE_ID;
    // let sectionMasterId = localStorage.getItem("sectionMasterId")

    const initialFormState = {
        instituteMasterId: instituteMasterId,
        sectionMasterId: '',
        academicYearMasterId: '',
        instituteGradeMasterId: '',
        instituteDivisionMasterId: '',
        isActive: true
    }


    const [sectionList, setSectionList] = useState([]);
    const [gradeList, setGradeList] = useState([])
    const [divisionList, setDivisionList] = useState([])
    const [yearList, setYearList] = useState([])
    const [studentData, setStudentData] = useState(initialFormState)
    const [studentList, setStudentList] = useState([])

    const [startIndex, setStartIndex] = useState(null);
    const [currPage, setCurrPage] = useState(1);
    const [itemsPerPage, setItemsPerPage] = useState(10);
    const [displayedData, setDisplayedData] = useState([]);
    const [totalPages, setTotalPages] = useState(0);
    const [saveId, setSaveId] = useState(null);

    const [sectionNameSort, setSectionNameSort] = useState(null);
    const [studentUniqueIdSort, setStudentUniqueIdSort] = useState(null);
    const [studentIdSort, setStudentIdSort] = useState(null);
    const [regIdSort, setRegIdSort] = useState(null);
    const [studentNameSort, setStudentNameSort] = useState(null);
    const [academicYearSort, setAcademicYearSort] = useState(null);

    const [searchValue, setSearchValue] = useState(null);
    const searchKeys = [
        "sectionMasterDetails.sectionName",
        "studentId",
        "std_id",
        "regis_no",
        "studentName",
        "academicYearMasterDetails.yearName",
        "instituteGradeMasterDetails.gradeName",
        "instituteDivisionMasterDetails.divisionName",
        "primaryContact",
        "email"
    ];


    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();
    const handleNavigate = (route) => {
        navigate(route);
    };

    useEffect(() => {
        getSectionList();
        // getGradeList()
        // getYearList()
    }, []);

    useEffect(() => {
        getStudentList();
    }, [studentData]);

    const getStudentList = async () => {
        // if (studentData.academicYearMasterId !== '') {
            try {
                const response = await authorizedAxios.get(getApiUrl());
                setStudentList(response.data.data);
                // setIsAllActive(checkAllActive(response.data.result.rows))
            } catch (error) {
                setStudentList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            }
        // }
    }

    useEffect(() => {
        if (searchValue === '' && searchValue !== null) {
            setCurrPage(1);
            getStudentList();
        }
    }, [searchValue]);

    const handleEmptySearch = (e) => {
        setSearchValue(e.target.value);
    }

    const handleSearch = async () => {
        if (searchValue !== null) {
            // if (studentData.academicYearMasterId !== '') {
                setCurrPage(1);
                setStudentList(await searchArray("A", getApiUrl(), searchKeys, searchValue.trim(), "data"));
            // }
        }
    }

    useEffect(() => {
        if (saveId) {
            const pageNumber = findPageNumber(studentList, saveId, itemsPerPage);
            setCurrPage(pageNumber);
        }
    }, [saveId])

    useEffect(() => {
        setTotalPages(Math.ceil(studentList.length / itemsPerPage));
        const startIndex = (currPage - 1) * itemsPerPage;
        let endIndex = startIndex + itemsPerPage;

        if (endIndex > studentList.length) {
            endIndex = studentList.length;
        }
        setStartIndex(startIndex);
        setDisplayedData(studentList.slice(startIndex, endIndex));
    }, [studentList, currPage, itemsPerPage]);

    const getSectionList = () => {
        const apiUrl = `/get-section?instituteMasterId=${instituteMasterId}`;
        authorizedAxiosInstitute && authorizedAxiosInstitute.get(apiUrl)
            .then(response => {
                setSectionList(response.data.result)
            })
            .catch(error => {
                setSectionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getApiUrl = () => {
        let apiUrl = `/get-app-registered-student-list?isActive=${studentData.isActive}&`;
        if (studentData.instituteMasterId !== '') {
            apiUrl += `instituteMasterId=${studentData.instituteMasterId}&`;
        }
        if (studentData.sectionMasterId !== '') {
            apiUrl += `sectionMasterId=${studentData.sectionMasterId}&`;
        }
        if (studentData.academicYearMasterId !== '') {
            apiUrl += `academicYearMasterId=${studentData.academicYearMasterId}&`;
        }
        if (studentData.instituteGradeMasterId !== '') {
            apiUrl += `instituteGradeMasterId=${studentData.instituteGradeMasterId}&`;
        }
        if (studentData.instituteDivisionMasterId !== '') {
            apiUrl += `instituteDivisionMasterId=${studentData.instituteDivisionMasterId}&`;
        }

        apiUrl = apiUrl.replace(/&$/, '');
        return apiUrl;
    }

    const getYearList = (sectionMasterId) => {
        let apiUrl = `/get-sections-academic-years?`;
        if(sectionMasterId) {
            apiUrl += `sectionMasterId=${sectionMasterId}`;
        }
        apiUrl = apiUrl.replace(/&$/, '');
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setYearList(response.data.data)
            })
            .catch(error => {
                setYearList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const getGradeList = (sectionMasterId) => {
        const apiUrl = `/get-app-register-section-grades?instituteMasterId=${instituteMasterId}&sectionMasterId=${sectionMasterId}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setGradeList(response.data.result)
            })
            .catch(error => {
                setGradeList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    const handleInputChange = (e) => {
        setStudentData((prevData) => {
            return {
                ...prevData,
                [e.target.name]: e.target.value
            }
        })
    }

    const handleSectionChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                [name]: value,
                instituteDivisionMasterId: '',
            }
        });

        getYearList(value);
        getGradeList(value);
    }

    const handleGradeChange = (e) => {
        const { name, value } = e.target;
        setStudentData((prevData) => {
            return {
                ...prevData,
                instituteDivisionMasterId: '',
                [name]: value
            }
        })

        const apiUrl = `/grade-wise-division?instituteMasterId=${instituteMasterId}&instituteGradeMasterId=${value}`;
        authorizedAxiosSection && authorizedAxiosSection.get(apiUrl)
            .then(response => {
                setDivisionList(response.data.result);
            })
            .catch(error => {
                setDivisionList([]);
                const errorMsg = error?.response?.data?.message || 'Something went wrong!';
                console.error('Error fetching data:', errorMsg);
            });
    }

    // const changeActive = async (id, activationStatus) => {
    //     setLoading(true);
    //     const data = {
    //         sectionMasterId,
    //         instituteMasterId,
    //         studentId: id,
    //         activationStatus,
    //     };

    //     const apiUrl = `/students-activation`;

    //     try {
    //         const response = await authorizedAxiosSection.patch(apiUrl, data);
    //         await getStudentList();

    //         setStudentIdSort(null);
    //         setRegIdSort(null);
    //         setStudentNameSort(null);

    //         setTimeout(() => {
    //             Swal.fire({ text: response.data.message });
    //         }, 100);
    //     } catch (error) {
    //         const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //         Swal.fire({ text: errorMsg });
    //     } finally {
    //         setLoading(false); // End loading
    //     }
    // };

    // const changeBulkActiveInactive = async (data) => {
    //     setLoading(true);
    //     const apiUrl = `/bulk-students-activation`;

    //     try {
    //         const response = await authorizedAxiosSection.patch(apiUrl, data);
    //         await getStudentList();

    //         setStudentIdSort(null);
    //         setRegIdSort(null);
    //         setStudentNameSort(null);

    //         Swal.fire({ text: response.data.message });
    //     } catch (error) {
    //         const errorMsg = error?.response?.data?.message || 'Something went wrong!';
    //         Swal.fire({ text: errorMsg });
    //     } finally {
    //         setLoading(false); // End loading
    //     }
    // };


    // const checkAllActive = (data) => {
    //     return data.every(item => item.isActive);
    // }

    // const getIdsByActiveState = (data) => {
    //     // Check if all elements have isActive as true
    //     const isAllActive = data.every(item => item.isActive);

    //     // Check if all elements have isActive as false
    //     const isAllInactive = data.every(item => !item.isActive);

    //     // If all are active or all are inactive, return all ids
    //     const studentIds = isAllActive || isAllInactive
    //         ? data.map(item => item.id)
    //         : data.filter(item => !item.isActive).map(item => item.id);

    //     // Check the activation status of any one ID, here taking the first ID for example
    //     const idToCheck = studentIds[0]; // Assuming you want to check the first ID
    //     const studentToCheck = data.find(item => item.id === idToCheck);

    //     let activationStatus;
    //     if (studentToCheck) {
    //         activationStatus = studentToCheck.isActive ? 0 : 1; // 0 for active, 1 for inactive
    //     } else {
    //         activationStatus = 1; // If the ID is not found, consider it inactive (optional)
    //     }

    //     return {
    //         activationStatus,
    //         studentIds
    //     };
    // };

    const handleInputReset = () => {
        setStudentData(initialFormState)
        setStudentList([])
        // setIsAllActive(false);

        setSectionNameSort(null);
        setStudentUniqueIdSort(null);
        setStudentIdSort(null);
        setRegIdSort(null);
        setStudentNameSort(null);
        setAcademicYearSort(null);
    }


    useEffect(() => {
        if (sectionNameSort == true || sectionNameSort == false) {
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [sectionNameSort])

    useEffect(() => {
        if (studentUniqueIdSort == true || studentUniqueIdSort == false) {
            setSectionNameSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [studentUniqueIdSort])

    useEffect(() => {
        if (studentIdSort == true || studentIdSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [studentIdSort])

    useEffect(() => {
        if (regIdSort == true || regIdSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setStudentNameSort(null);
            setAcademicYearSort(null);
        }
    }, [regIdSort])

    useEffect(() => {
        if (studentNameSort == true || studentNameSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setAcademicYearSort(null);
        }
    }, [studentNameSort])

    useEffect(() => {
        if (academicYearSort == true || academicYearSort == false) {
            setSectionNameSort(null);
            setStudentUniqueIdSort(null);
            setStudentIdSort(null);
            setRegIdSort(null);
            setStudentNameSort(null);
        }
    }, [academicYearSort])


    return (
        <>
            <Loader loading={loading} />
            <div className="wrapper d-flex flex-column min-vh-100 bg-light">
                <Header />
                <div className="container-fluid">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb my-0 ms-2">
                            <li className="breadcrumb-item dashboard" onClick={() => handleNavigate('/dashboard')}>
                                <span>Dashboard</span>
                            </li>
                            <li className="breadcrumb-item active"><span>App Registered Student</span></li>
                        </ol>
                    </nav>
                </div>

                <div className="container-lg">
                    <div className="row">
                        <div className="card border-info mx-auto mt-3">
                            <div className="card-content collpase show">
                                <div className="card-header" style={{ backgroundColor: '#3081D0', borderRadius: 0 }}>
                                    <h4 className="text-white"><b><span className="fa fa-file-o"></span><i class="fa-solid fa-users-line"></i>App Registered Student</b></h4>
                                </div>
                                <div className="card-body ">
                                    <div className="row">
                                        <div className="col-md-12">
                                            <div className="row">
                                                <div className="col-md-6">
                                                    <label for="sectionMasterId" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Section</label>
                                                    <select class="form-select" aria-label="Default select example" name='sectionMasterId' onChange={handleSectionChange} value={studentData.sectionMasterId} >
                                                        <option selected value={''} disabled>Select Section</option>
                                                        {
                                                            sectionList?.map((section) => {
                                                                return <option value={section.id}>{section.sectionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                    {/* <ErrorMessage errors={error} field="sectionMasterId" /> */}
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Academic Year :</label>
                                                    <select class="form-select" aria-label="Default select example" name='academicYearMasterId' onChange={handleInputChange} value={studentData.academicYearMasterId}>
                                                        <option selected value={''} disabled>Select Academic Year</option>
                                                        {
                                                            yearList?.map((list) => {
                                                                return <option value={list?.academicYearMasterDetails?.id}>{list?.academicYearMasterDetails?.yearName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Class :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteGradeMasterId' onChange={handleGradeChange} value={studentData.instituteGradeMasterId}>
                                                        <option selected value={''} disabled>Select Class</option>
                                                        {
                                                            gradeList?.map((grade) => {
                                                                return <option value={grade.instituteGradeMasterId}>{grade.instituteGradeMasterDetails.gradeName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-6">
                                                    <label for="inputPassword" className="col-form-label"><span style={{ color: "red" }}>*</span>Select Division :</label>
                                                    <select class="form-select" aria-label="Default select example" name='instituteDivisionMasterId' onChange={handleInputChange} value={studentData.instituteDivisionMasterId}>
                                                        <option selected value={''} disabled>Select Division</option>
                                                        {
                                                            divisionList?.map((division) => {
                                                                return <option value={division.id}>{division.divisionName}</option>
                                                            })
                                                        }
                                                    </select>
                                                </div>
                                                <div className="col-md-12 mt-3 mb-1" style={{ textAlign: 'center' }}>
                                                    <div className="col-auto">
                                                        <button className="btn btn-danger delete_icon" type="button" style={{ marginRight: "20px" }} onClick={handleInputReset}>Reset</button>
                                                    </div>
                                                </div>
                                            </div>

                                            <div className="row">
                                                <div className="d-grid gap-2 mt-2">
                                                    <div class="tab-content rounded-bottom custom_table">
                                                        <div className="row mb-2">
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.isActive ? 'active' : ''} btn btn-light btn-width`} onClick={() => setStudentData(prev => ({ ...prev, isActive: true }))}>Active List</button>
                                                            </div>
                                                            <div className="col-md-6">
                                                                <button className={`${studentData.isActive ? '' : 'active'} btn btn-light btn-width`} onClick={() => setStudentData(prev => ({ ...prev, isActive: false }))}>Inactive List</button>
                                                            </div>
                                                        </div>
                                                        <div className='search_btn_row'>
                                                            <input
                                                                className="form-control mr-sm-2"
                                                                type="Search"
                                                                placeholder="Search"
                                                                value={searchValue}
                                                                onChange={handleEmptySearch}
                                                                onKeyDown={(event) => {
                                                                    if (event.key === 'Enter') {
                                                                        handleSearch();
                                                                    }
                                                                }}
                                                            />
                                                            <button className="btn btn-outline-primary" onClick={handleSearch}><i class="fa fa-search" aria-hidden="true"></i></button>
                                                        </div>
                                                        <div class="tab-pane p-3 active preview" role="tabpanel" id="preview-1000">
                                                            <table class="table">
                                                                <thead>
                                                                    <tr>
                                                                        <th scope="col" className='sl_no'>Sr. No.</th>
                                                                        <th scope='col'>
                                                                            Section Name
                                                                            <SortIcon sortState={sectionNameSort} setSortState={setSectionNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"sectionMasterDetails.sectionName"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            User Name
                                                                            <SortIcon sortState={studentUniqueIdSort} setSortState={setStudentUniqueIdSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentId"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Std Id
                                                                            <SortIcon sortState={studentIdSort} setSortState={setStudentIdSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"std_id"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Reg Id
                                                                            <SortIcon sortState={regIdSort} setSortState={setRegIdSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"regis_no"} />
                                                                        </th>
                                                                        <th scope="col">
                                                                            Name
                                                                            <SortIcon sortState={studentNameSort} setSortState={setStudentNameSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"studentName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Academic Year
                                                                            <SortIcon sortState={academicYearSort} setSortState={setAcademicYearSort} setData={setStudentList} setCurrPage={setCurrPage} sortingPath={"academicYearMasterDetails.yearName"} />
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Class
                                                                        </th>
                                                                        <th scope='col'>
                                                                            Division
                                                                        </th>
                                                                        <th scope="col">Phone No</th>
                                                                        <th scope="col">Email</th>
                                                                        {/* <th scope='col'>
                                                                            Active/Inactive
                                                                            {studentList.length > 0 && <div className={`toggle-container ${isAllActive ? 'active' : ''}`} onClick={() => changeBulkActiveInactive(getIdsByActiveState(studentList))} >
                                                                                <div className="toggle-background"></div>
                                                                                <div className="toggle-switch"></div>
                                                                            </div>}
                                                                        </th> */}
                                                                    </tr>
                                                                </thead>
                                                                <tbody>
                                                                    {
                                                                        displayedData?.length > 0 ?
                                                                            displayedData?.map((std, index) => {
                                                                                return (
                                                                                    <tr>
                                                                                        <th scope="row" className='sl_no'>{startIndex + index + 1}</th>
                                                                                        <td>{std.sectionMasterDetails.sectionName}</td>
                                                                                        <td>{std.studentId}</td>
                                                                                        <td>{std.std_id}</td>
                                                                                        <td>{std.regis_no}</td>
                                                                                        <td>{std.studentName}</td>
                                                                                        <td>{std.academicYearMasterDetails.yearName}</td>
                                                                                        <td>{std.instituteGradeMasterDetails.gradeName}</td>
                                                                                        <td>{std.instituteDivisionMasterDetails.divisionName}</td>
                                                                                        <td>{std.primaryContact}</td>
                                                                                        <td>{std.email}</td>
                                                                                        {/* <td>
                                                                                            <div className={`toggle-container ${std.isActive ? 'active' : ''}`} onClick={() => changeActive(std.id, !std.isActive)}>
                                                                                                <div className="toggle-background"></div>
                                                                                                <div className="toggle-switch"></div>
                                                                                            </div>
                                                                                        </td> */}
                                                                                    </tr>
                                                                                )
                                                                            })
                                                                            :
                                                                            (<tr>
                                                                                <th colspan={"100%"} style={{ textAlign: 'center' }}>No Students Available</th>
                                                                            </tr>)
                                                                    }
                                                                </tbody>
                                                            </table>
                                                            <Pagination currPage={currPage} setCurrPage={setCurrPage} totalPages={totalPages} itemsPerPage={itemsPerPage} setItemsPerPage={setItemsPerPage} totalItem={studentList.length} />
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
};

export default AppRegisteredStudentList
